import React, { useState, useEffect } from "react";
import { COMM_CREDIT_LIST_URL } from "../../utils/urls.js";
import instance from "../../services/services";
import SupportPopup from '../../components/Popup/SupportPopup';
import PaginationSection from '../../components/Product/Pagination';
import { useLanguage } from "../../hooks/useLanguage";

function CreditList(){
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('');
  const [creditItem, setCreditItem] = useState([]);
  const [supportPop, setSupportPop] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedWorkSeq, setSelectedWorkSeq] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);
  
  // 반응형 itemsPerPage 설정
  const itemsPerPage = isMobile ? 12 : 10;
  
  const tabList = [
    {name: t("all"), value:'' },
    {name: t("cinema"), value:'cinema' },
    {name: t("drama"), value:'drama' },
    {name: "ETC", value:'etc' },
  ];

  const handleTabClick = (value) => {
    setActiveTab(value);
    setCurrentPage(1);
  };

  const handleViewMore = (workSeq) => {
    setSelectedWorkSeq(workSeq);
    setSupportPop(true);
  };


  // 크레딧 리스트 api
  useEffect(() => {
    const fetchCreditList = async () => {
      try {
        const response = await instance.post(COMM_CREDIT_LIST_URL, {
          credit_kind: activeTab,
          limit : itemsPerPage,
          offset : currentPage
        });
        setCreditItem(response.data.data.data);
        setTotalCount(response.data.data.cntRow);
      } catch (error) {
        console.error("1:1문의 목록 가져오기실패:", error);
      }
    };
    fetchCreditList();
  }, [activeTab, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // window.scrollTo(0, 0); // 페이지 상단으로 스크롤
  };

  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  // 화면 크기 변경 감지
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return(
    <div className="board_container credit_list_page">
      <h3 className="commu_title noline">{t("credit")}</h3>

      <div className="round_tab mb_24">
        <ul className="tab_list">
          {tabList.map((tab, index) => (
            <li
              key={index}
              className={`tab_item ${activeTab === tab.value ? 'active' : ''}`}
              onClick={() => handleTabClick(tab.value)}
            >
              <button className="flex-center-4 flex-justify-center">
                {tab.name}
              </button>
            </li> 
          ))} 
        </ul>
      </div>


      <ul className="resp_container support_list credit_list">
        {creditItem.map((item,index) => (

          <li 
            key={index} 
            className="support_item credit_img"
            onClick={() => handleViewMore(item.credit_seq)}  
          >
            <img src={item.thumbnail} alt="event" loading="lazy"/>
            <div className="support_info credit_info">
              <h6 className="title ellipsis1">{item.work_title}</h6>
            </div>
          </li>
        ))}
      </ul>

      {totalCount > 0 && (
      <div className="pagination_wrap">
        <PaginationSection
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onArrow={handleArrowClick}
          />
        </div>
      )}

      <SupportPopup
        isPopup={supportPop}
        setIsPopup={setSupportPop}
        commType="credit"
        workSeq={selectedWorkSeq}
      />
    </div>
  )
};

export default CreditList;